var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskAppetiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 97,
    viewBox: "0 0 98 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 48.5,
    r: 48.5,
    fill: "#EEF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 52.5C64.5 52.1022 64.342 51.7206 64.0607 51.4393C63.7794 51.158 63.3978 51 63 51H57C56.6022 51 56.2206 51.158 55.9393 51.4393C55.658 51.7206 55.5 52.1022 55.5 52.5V66H52.5V33.5C52.5 32.044 52.496 31.1 52.404 30.408C52.316 29.758 52.174 29.554 52.06 29.44C51.946 29.326 51.742 29.184 51.092 29.096C50.398 29.004 49.456 29 48 29C46.544 29 45.6 29.004 44.908 29.096C44.258 29.184 44.054 29.326 43.94 29.44C43.826 29.554 43.684 29.758 43.596 30.408C43.504 31.102 43.5 32.044 43.5 33.5V66H40.5V42.5C40.5 42.1022 40.342 41.7206 40.0607 41.4393C39.7794 41.158 39.3978 41 39 41H33C32.6022 41 32.2206 41.158 31.9393 41.4393C31.658 41.7206 31.5 42.1022 31.5 42.5V66H28C27.6022 66 27.2206 66.158 26.9393 66.4393C26.658 66.7206 26.5 67.1022 26.5 67.5C26.5 67.8978 26.658 68.2794 26.9393 68.5607C27.2206 68.842 27.6022 69 28 69H68C68.3978 69 68.7794 68.842 69.0607 68.5607C69.342 68.2794 69.5 67.8978 69.5 67.5C69.5 67.1022 69.342 66.7206 69.0607 66.4393C68.7794 66.158 68.3978 66 68 66H64.5V52.5Z",
    fill: "#B8C8CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAppetiteIcon);
export default __webpack_public_path__ + "static/media/risk-appetite-icon.e137eb544facc7ff2ad60155a5bdf4d9.svg";
export { ForwardRef as ReactComponent };